import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myPart2 } from "@/lib/api";
import { pick, fmtDate, canOpenDay } from "./part2Util";

export default function Part2() {
  const { lang, user } = useApp();
  const t = useAppUi(lang);
  const [data, setData] = useState(null);
  useEffect(() => { myPart2().then(setData).catch(() => setData({ access: false, days: [] })); }, []);

  return (
    <PLayout>
      <div className="rbl-eyebrow">{t("p2Kicker")}</div>
      <h1 className="rbl-h1" style={{ fontSize: 40 }} data-testid="part2-title">{t("p2Title")}</h1>
      {data && !data.access && <p className="rbl-intro" data-testid="part2-no-access">{t("p2NoAccess")}</p>}
      {data?.access && (
        <>
          <p className="rbl-intro">{t("p2Intro")}</p>
          <div className="rbl-grid" style={{ marginTop: 24 }} data-testid="part2-days">
            {data.days.map((d, i) => {
              const open = canOpenDay(d.day_number, user?.role);
              const Tag = open ? Link : "div";
              return (
              <Tag to={open ? `/app/part2/${d.day_number}` : undefined} className={`rbl-card ${open ? "" : "locked"}`} key={d.day_number} data-testid={`part2-day-${d.day_number}`}>
                <span className="rbl-card-num">{t("dayLabel").toUpperCase()} {String(d.day_number).padStart(2, "0")}</span>
                <span className="rbl-card-title">{pick(d.title, lang)}</span>
                <span className="rbl-card-meta">{pick(d.subtitle, lang)}</span>
                <span className="rbl-card-meta" style={{ marginTop: 6 }}>
                  🕘 {d.hours}{data.dates?.[i] ? ` · ${fmtDate(data.dates[i], lang)}` : ""}
                </span>
                <span className="rbl-card-cta">{open ? `${t("openDay")} →` : `🔒 ${t("lockedSoon")}`}</span>
              </Tag>
              );
            })}
          </div>
        </>
      )}
    </PLayout>
  );
}
